var swiper =  new Swiper(".comp-four-cards__slider", {
  slidesPerView: 4,
  spaceBetween: 0,
  loop: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1200: { slidesPerView: 4 },
    992: { slidesPerView: 4 },
    768: { slidesPerView: 3, spaceBetween: 10 },
    0: { slidesPerView: 1.8, spaceBetween: 10 },
  },
});